import {useTranslation} from "react-i18next";
import React, { useState } from "react";
import {Block, Title} from '../../../components/components';
import { useHistory } from 'react-router';
import useCustomTable from "../../../components/tables/useCustomTable";
import Table from "../../../components/tables/Table";
import TableSearch from "../../../components/tables/TableSearch";
import Pagination from "../../../components/tables/Pagination";
import FilterButton, {FilterGroup} from "../../../components/FilterButton";
import { useGetPublishersQuery } from "../../../api/publisherApiSlice";
import EnabledBadge from "../../../components/metrics/tables/cells/EnabledCell";
import { Button } from "react-bootstrap";
import Icon from "../../../components/Icon";
import NewModalForm from "../../../components/publisher/NewModalForm";
import * as Format from "../../../components/Format";
import {CellTwoLines} from "../../../components/tables/CellTwoLines";
import capitalize from "lodash/capitalize";
import { Loader } from "../../../components/components";

const relevantDate = (publisher) => {
  if ( publisher.environment == 'production' ) { return publisher.production_date }
  if ( publisher.environment == 'test' ) { return publisher.test_date }
  return publisher.created_at
}

const EnvironmentCell = ({publisher}) => {
  return(<CellTwoLines text={capitalize(publisher.environment)} subtext={Format.formatDate(relevantDate(publisher))} />)
}

const PublishersList = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: publishers = [], isSuccess, isLoading } = useGetPublishersQuery()
  const [modalNewShow, setModalNewShow] = useState(false);

  const columns = [{
    Header: 'Name',
    accessor: 'name',
    sortType: (rowA, rowB, id, desc) => (rowB.original.name.localeCompare(rowA.original.name))
  },{
    Header: 'Environment',
    Cell: ({row}) => (<EnvironmentCell publisher={row.original} />),
    accessor: 'environment',
  },{
    Header: 'Apps',
    accessor: 'apps_count',
  },{
    Header: 'Devices',
    accessor: 'devices_count',
  },{
    Header: 'Geolocated devices',
    accessor: 'location_authorized_devices',
  },{
    Header: 'Opt-in geolocation',
    Cell: ({row}) => <Format.Percent value={(100 * row.original.loc_authorization_rate)}/>,
    accessor: 'loc_authorization_rate',
    sortType: (rowA, rowB, id, desc) => (rowB.original.loc_authorization_rate - rowA.original.loc_authorization_rate)
  },{
    Header: 'Consent',
    accessor: 'loc_consented_devices',
  },{
    Header: 'Consent (%)',
    Cell: ({row}) => <Format.Percent value={(100 * row.original.loc_consented_devices_rate)}/>,
    accessor: 'loc_consented_devices_rate',
    sortType: (rowA, rowB, id, desc) => (rowB.original.loc_consented_devices_rate - rowA.original.loc_consented_devices_rate)
  },{
    Header: 'Enabled',
    Cell: ({row}) => (<EnabledBadge enabled={row.original.enabled} />),
    accessor: 'enabled',
  }];

  const tableOptions = {
    sortable: true,
    paginate: true
  };

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps,
  } = useCustomTable(tableOptions)

  const showPublisher = (data) => history.push(`/publishers/${data.slug}`)

  if ( !isSuccess ) { return(<></>) }

  return (
    <>
      <Title main={t("menu.publishers")}>
        <Button onClick={()=>(setModalNewShow(true))}>
          <Icon icon='plus' text={t("new")} />
        </Button>
      </Title>
      <NewModalForm
        show={modalNewShow}
        onHide={() => setModalNewShow(false)}
      />
      <FilterGroup {...tableFilterProps}>
        <FilterButton
          title={t("publisher.environment")}
          options={["Created", "Test", "Production", "Terminated"]}
          search={false}
          includeAll={false}
          name="environment"/>
        <TableSearch {...tableSearchProps} style={{float: "right"}}/>
      </FilterGroup>
      <Block className="mb-0">
        <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
          <Table
            data={publishers}
            columns={columns}
            onRowClick={showPublisher}
            {...tableProps} />
        </Loader>
      </Block>
      <Pagination {...paginationProps}/>
    </>
  )
}

export default PublishersList
